/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const StandAloneCtaFragment = {
  StandAloneCta: gql`
    fragment StandAloneCtaQuery on standAloneCta_Entry {
      ctaLabel
      ctaLink
      ctaNewTab
      ctaNofollow
      ctaType
      ctaTag
      displayPrice
      lineBreak_content
      lineBreak_style
      pricingText
      styles
      typeHandle
    }
  `,
};
